import React, { FC, memo, ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router";
import { auth } from '../../firebase';
import { useDispatch, useSelector } from "react-redux";
import { login, logout, selectAuth } from "../../features/auth.slice";


type Props = {
  children: ReactNode
}

export const AuthUserRoute: FC<Props> = memo((props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const user = useSelector(selectAuth);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
     auth.onAuthStateChanged((authUser:any) => {
      if (authUser) {
        dispatch(login({
          uid: authUser.uid,
          photoUrl: authUser.photoURL,
          displayName: authUser.displayName,
        }));
        setIsLoading(false);
      } else {
        dispatch(logout());
        setIsLoading(false);
      }
    });
  }, [dispatch]);
  return (
    <>
      {!isLoading && (
        <>{user.uid ? (
          <>
            {children}
          </>
        ) : (
          <>
            <Navigate to="/login" />
          </>
        )}
        </>
      )}
    </>
  );
});